import { Grid, Typography } from "@mui/material"
import { useUserCreator } from "./styles"

const UserCreator = (props: any) => {
  const styles = useUserCreator()
  let usersAssigned = props?.current
  return (
    <Grid
      container
      justifyContent="left"
      alignItems="center"
      columnSpacing={1}
    >
      <Grid
        item
        sx={{ color: '#828282' }}
        xl={10}
        lg={10}
        md={10}
        sm={10}
        xs={10}
      >
        <Typography sx={styles.textItem}>
          {usersAssigned.length ? (
            <span>{usersAssigned}</span>
          ) : (
            'N/A'
          )}
        </Typography>
      </Grid>
    </Grid>
  )
}

export { UserCreator }
